module.exports = __webpack_public_path__ + "h5/img/test1.eae4f2e4.png";